<!-- <div [@slidepanel]="showleftpanel" [style.width.px]="leftpanelwidth" mwlResizable [resizeEdges]="{ right: true }"
    [validateResize]="validateResize" [resizeCursorPrecision]="5" [enableGhostResize]="true"
    [resizeSnapGrid]="{ left: 1, right: 1 }" (resizeEnd)="onResizeEnd($event)" [style.top]="getHeaderMenuHeight()+'px'"
    style="position: absolute;z-index:20; float:left; left: 0px;max-width:86%;padding:10px 0;background:white;padding:6px 12px 10px 12px;border-top-right-radius:7px; border-bottom-right-radius:7px;border-right: 4px dashed lightgray;border-radius: 0px;bottom: 0px;"
    class="m2at-elevation-z2 "> -->
<!-- <div style="position:relative;cursor:pointer;">
        <a id="infotoggle" class="infotoggle btn btn-primary" (click)="switchsidepanel()"
            style="  background-color: #95c21e;border-color: #84ac1b;position: absolute;  color:white; z-index: 100;    top: 10px;     right: -56px;    padding: 2px 1px; ">
            <i style="width:40px" class="fa  fa-2x fa-times"></i>
        </a>
    </div> -->

<!-- <div style="position:absolute;z-index:99">
     <ng-container style="font-size:9px;">
        <ng-template #recursiveList1 let-list>
            <ng-container *ngFor="let item of (list|keyvalue:keepOriginalOrder ) ; let i = index">
                <div style="padding-left:20px;border:1px solid gray;font-size: 8px;">{{i}} {{item.value.controlName}}
                </div>
                <ng-container *ngTemplateOutlet="recursiveList1; context:{ $implicit: item?.value?.childs  }">
                </ng-container>
            </ng-container>
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveList1; context:{ $implicit: jsongui?.childs  }">
        </ng-container>
    </ng-container> 
</div> -->



<!-- TABS -->
<!-- rekursion: https://gist.github.com/arniebradfo/5cf89c362cc216df6fc1d9ca4d536b72 -->
<ng-container style="font-size:9px;">

    <!-- <div>{{projectdata}}</div>
    <hr> -->

    <ng-template #recursiveList let-list>
        <!-- List2:{{list|keyvalue:keepOriginalOrder |json}} -->



        <ng-container *ngFor="let item of (list|keyvalue:keepOriginalOrder ) ; let i = index">
            <ng-container>
                <ng-container *ngIf="item?.value?.isVisible ">
                    <!-- # {{item.value.controlName}} -->
                    <mat-tab-group *ngIf="item.value.typ==='TAB'">
                        <mat-tab [label]="(item.value.label | translatesplit:lang)" [class.selected_widget]="item.value.selected" *ngIf="item.value.typ==='TAB'">
                            <div class="panelcontent" *ngIf="item.value">
                                <ng-container *ngIf="item.value.childs ">
                                    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.value.childs }">
                                    </ng-container>
                                </ng-container>
                            </div>
                        </mat-tab>
                    </mat-tab-group>

                    <div *ngIf="item?.value?.groupboxTyp==='EXPANSION'" style="margin-bottom:3px;">
                        <mat-accordion>
                            <mat-expansion-panel [expanded]='false'>
                                <mat-expansion-panel-header>
                                    <mat-panel-title style="font-weight:bold;">
                                        {{item?.value?.label | translatesplit:lang}}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div style="overflow:hidden;" *ngIf="item?.value?.childs">
                                    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item?.value?.childs   }"></ng-container>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>

                    <!-- label  -->
                    <div [id]="item.value.controlName+'-row'" [class]="item.value.cssclass" [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='LABEL'">
                        <div class="row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <label [id]="item.value.controlName" class="col-sm-12 ">{{item.value.label |
                                translatesplit:lang}}</label>
                        </div>
                    </div>
                    <style>
                        .cell-label {
                            position: absolute;
                            top: 19px;
                            left: 0;
                            background: rgb(115, 30, 115);
                            color: white;
                            padding: 2px;
                            border-radius: 3px;
                        }
                    </style>
                    <!-- slider -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='SLIDER'">
                        <div class=" row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <label class="col-sm-4">{{item.value.label | translatesplit:lang}}</label>
                            <mat-slider [id]="item.value.controlName" [min]="item.value.minValue" [max]="item.value.maxValue" step="1">
                                <input matSliderThumb (input)="sliderChange($event, item)" [(ngModel)]="item.value.outputValue">
                            </mat-slider>
                            <!-- (change)="controlC(item.value)" -->
                            <input type="number" [(ngModel)]="item.value.outputValue" (change)="controlC(item.value)" [min]="item.value.minValue" [max]="item.value.maxValue" class="form-control form-control-sm"
                                style="width: 65px; display: inline-block;margin-top:8px;">
                            <!-- <ngx-slider (userChange)="controlC(item.value)" [(value)]="item.value.outputValue"
                                [options]="slideroptions"></ngx-slider> -->
                        </div>
                    </div>

                    <!-- Textbox -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='TEXTBOX'">
                        <div class="form-group row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <label class="col-sm-4">{{item.value.label | translatesplit:lang}}</label>
                            <input [id]="item.value.controlName" [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam" [id]="item.value.controlName" [(ngModel)]="item.value.outputValue"
                                (click)="controlC(item.value)" class="col-sm-7 form-control form-control-sm" (blur)="controlC(item.value)" (focus)="focusControl(item.value.controlName)" />

                            <span *ngIf="item.value.edited" style="    padding: 6px 3px;    height: 31px;    right: 20px;" (click)="controlC( { resetitem:true, item:item.value })"><i
                                    class="fa  far far fa-window-close"></i></span>
                        </div>
                    </div>

                    <!-- Checkbox -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" style="text-align:left;" [class.selected_widget]="item.value.selected" *ngIf="item.value.typ==='CHECKBOX'"
                        style="text-align:center;">
                        <div class="form-group form-check row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <input [id]="item.value.controlName" type="checkbox" style="margin-right:6px" [(ngModel)]="item.value.outputValue" (click)="controlC(item.value)"
                                (focus)="focusControl(item.value.controlName)" />
                            <label class="form-check-label" [for]="item.value.controlName">{{item.value.label |
                                translatesplit:lang}}</label>
                        </div>
                    </div>
                    <style class="cp-pen-styles">
                        .nopad {
                            padding-left: 0 !important;
                            padding-right: 0 !important;
                        }

                        /*image gallery*/
                        .image-checkbox {
                            cursor: pointer;
                            box-sizing: border-box;
                            -moz-box-sizing: border-box;
                            -webkit-box-sizing: border-box;

                            float: left;
                        }

                        .image-checkbox input[type="checkbox"] {
                            display: none;
                        }

                        .image-checkbox-checked {
                            border-color: #4783B0;
                        }

                        .image-checkbox .fa {
                            position: absolute;
                            color: #4A79A3;
                            background-color: #fff;
                            padding: 10px;
                            top: 0;
                            right: 0;
                        }

                        .image-checkbox-checked .fa {
                            display: block !important;
                        }
                    </style>
                    <!-- RADIO -->
                    <div [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='RADIO'">
                        <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <!-- Check if radio has image options from selectOptions -->
                            <div *ngIf="hasRadioImageOptions(item); else textRadio" style="width: 100%;">
                                <!-- Radio Image Responsive Grid -->
                                <div class="radio-image-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 12px; margin-top: 8px;">
                                    <div *ngFor="let option of getRadioImageOptions(item); trackBy: trackImageOption" class="radio-image-option" [class.selected]="isRadioSelected(item, option.wert)"
                                        (click)="selectRadioImageOption(item, option.name, option.wert)"
                                        style="cursor: pointer; border: 2px solid transparent; border-radius: 8px; padding: 6px; transition: all 0.2s ease; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); position: relative; min-height: 120px;"
                                        [style.border-color]="isRadioSelected(item, option.wert) ? '#b84eff' : 'transparent'"
                                        [style.box-shadow]="isRadioSelected(item, option.wert) ? '0 4px 8px rgba(184, 78, 255, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.1)'"
                                        (mouseenter)="$event.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)'; $event.target.style.transform = 'translateY(-2px)'"
                                        (mouseleave)="$event.target.style.boxShadow = isRadioSelected(item, option.wert) ? '0 4px 8px rgba(184, 78, 255, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.1)'; $event.target.style.transform = 'translateY(0)'">

                                        <!-- Hidden radio input for proper form behavior -->
                                        <input type="radio" [name]="getRadioGroupName(item)" [value]="option.wert" [checked]="isRadioSelected(item, option.wert)"
                                            style="position: absolute; opacity: 0; pointer-events: none;">

                                        <!-- Image content -->
                                        <div *ngIf="isImageUrl(option.name); else radioTextOption" class="image-wrapper"
                                            style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; position: relative;">
                                            <img [src]="getFirstImageUrl(option.name)" [alt]="option.wert || 'Radio Image'" loading="lazy"
                                                style="width: 100%; height: 100%; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;" (load)="onImageLoad(getFirstImageUrl(option.name))"
                                                (error)="onImageError($event)">

                                            <!-- Selection indicator -->
                                            <div *ngIf="isRadioSelected(item, option.wert)"
                                                style="position: absolute; top: 6px; right: 6px; width: 24px; height: 24px; background: #b84eff; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);">
                                                <i class="fas fa-check" style="color: white; font-size: 12px;"></i>
                                            </div>

                                            <!-- Value label overlay -->
                                            <div *ngIf="option.wert"
                                                style="position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.8); color: white; padding: 4px 6px; font-size: 13px; font-weight: 500; text-align: center; border-radius: 0 0 6px 6px;">
                                                {{option.wert}}
                                            </div>
                                        </div>

                                        <ng-template #radioTextOption>
                                            <div class="text-option"
                                                style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 6px; font-size: 13px; text-align: center; background: #f8f9fa; position: relative;">
                                                {{option.wert || option.name}}

                                                <!-- Selection indicator for text options -->
                                                <div *ngIf="isRadioSelected(item, option.wert)"
                                                    style="position: absolute; top: 6px; right: 6px; width: 20px; height: 20px; background: #b84eff; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                                                    <i class="fas fa-check" style="color: white; font-size: 10px;"></i>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>

                            <!-- Traditional text radio buttons for non-image options -->
                            <ng-template #textRadio>
                                <div class="form-group row">
                                    <label class="col-sm-4" [for]="item.value.controlName">{{item.value.label | translatesplit:lang}}</label>
                                    <div class="col-sm-7">
                                        <!-- Single radio button (legacy support for simple cases) -->
                                        <div *ngIf="!item.value.selectOptions" class="form-check">
                                            <input class="form-check-input" type="radio" [id]="item.value.controlName" [name]="getRadioGroupName(item)" [checked]="item.value.outputValue" (change)="controlC(item.value)"
                                                [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam">
                                            <label class="form-check-label" [for]="item.value.controlName">
                                                {{item.value.label | translatesplit:lang}}
                                            </label>
                                        </div>

                                        <!-- Multiple radio options from selectOptions -->
                                        <div *ngIf="item.value.selectOptions" class="radio-group">
                                            <div *ngFor="let option of item.value.selectOptions; let i = index" class="form-check" style="margin-bottom: 8px;">
                                                <input class="form-check-input" type="radio" [id]="item.value.controlName + '_' + i" [name]="getRadioGroupName(item)" [value]="option.wert || option.name"
                                                    [checked]="isRadioSelected(item, option.wert || option.name)" (change)="selectRadioTextOption(item, option.wert || option.name)"
                                                    [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam">
                                                <label class="form-check-label" [for]="item.value.controlName + '_' + i">
                                                    {{option.wert || option.name}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>

                            <span *ngIf="item.value.edited" style="padding: 6px 3px; height: 31px; right: 20px;" (click)="controlC( { resetitem:true, item:item.value })">
                                <i class="fa far fa-window-close"></i>
                            </span>
                        </div>
                    </div>

                    <!-- </div> -->

                    <div *ngIf="item.value.typ=='divider'" style="clear:both">

                    </div>

                    <!-- <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="favoriteSeason">
    <mat-radio-button class="example-radio-button" *ngFor="let season of seasons" [value]="season"> 
        {{season}}
    </mat-radio-button>
</mat-radio-group> -->

                    <!-- colorchooser -->
                    <div [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='COLORCHOOSER'">
                        <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" class="form-group row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <label class="col-sm-4" [for]="item.value.controlName">{{item.value.label | translatesplit:lang}}</label>

                            <!-- Check if colorchooser has predefined color options -->
                            <div *ngIf="hasColorOptions(item); else singleColorPicker" class="col-sm-7">
                                <!-- Color Grid Selector (no traditional colorpicker when palette is shown) -->
                                <div class="color-select-wrapper" style="position: relative; width: 100%;">
                                    <div class="color-select-button" (click)="toggleColorDropdown(item.value.controlName)"
                                        style="display: flex; align-items: center; justify-content: space-between; padding: 6px 12px; border: 1px solid #ced4da; border-radius: 4px; background: white; cursor: pointer; min-height: 38px;"
                                        [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam">

                                        <!-- Selected color preview -->
                                        <div class="selected-color-preview" style="display: flex; align-items: center; flex: 1; gap: 8px;">
                                            <div *ngIf="getSelectedColor(item); else noColorSelected" style="display: flex; align-items: center; gap: 8px;">
                                                <div class="color-swatch" [style.background-color]="getSelectedColor(item)"
                                                    style="width: 24px; height: 24px; border: 1px solid #ccc; border-radius: 3px; display: inline-block;"></div>
                                                <span style="font-size: 14px; color: #333;">{{getSelectedColor(item)}}</span>
                                            </div>
                                            <ng-template #noColorSelected>
                                                <span style="color: #6c757d; font-size: 14px;">
                                                    Select a color...
                                                </span>
                                            </ng-template>
                                        </div>

                                        <!-- Dropdown arrow -->
                                        <i class="fas fa-chevron-down" style="color: #6c757d; font-size: 12px;"></i>
                                    </div>

                                    <!-- Color grid dropdown with bigger swatches and multiple rows -->
                                    <div [hidden]="!isColorDropdownOpen(item.value.controlName)" class="color-dropdown-content"
                                        style="position: absolute; top: 100%; left: -60px; right: -60px; z-index: 1000; background: white; border: 1px solid #ced4da; border-top: none; border-radius: 0 0 4px 4px; max-height: 500px; overflow-y: auto; overflow-x: hidden; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">

                                        <div class="color-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 4px; padding: 12px;">
                                            <div *ngFor="let color of getColorOptions(item); trackBy: trackColorOption" class="color-option" [class.selected]="item.value.outputValue === color"
                                                (click)="selectColorOption(item, color); closeColorDropdown(item.value.controlName)"
                                                style="cursor: pointer; border: 2px solid transparent; border-radius: 6px; padding: 2px; transition: all 0.2s ease; aspect-ratio: 1; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);"
                                                [style.border-color]="item.value.outputValue === color ? '#b84eff' : 'transparent'"
                                                [style.box-shadow]="item.value.outputValue === color ? '0 2px 4px rgba(184, 78, 255, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.1)'"
                                                (mouseenter)="$event.target.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.15)'; $event.target.style.transform = 'translateY(-1px)'"
                                                (mouseleave)="$event.target.style.boxShadow = (item.value.outputValue === color) ? '0 2px 4px rgba(184, 78, 255, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.1)'; $event.target.style.transform = 'translateY(0)'">

                                                <div class="color-swatch" [style.background-color]="color" style="width: 100%; height: 100%; border-radius: 4px; border: 1px solid #ddd;" [title]="color">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Traditional single color picker -->
                        <ng-template #singleColorPicker>
                            <div class="col-sm-7" style="position: relative;">
                                <input [(colorPicker)]="item.value.outputValue" [value]="item.value.outputValue" (colorPickerChange)="controlC(item.value)" [style.background]="item.value.outputValue+'!important'"
                                    class="form-control form-control-sm" [cpUseRootViewContainer]="true">
                            </div>
                        </ng-template>

                        <span *ngIf="item.value.edited" style="padding: 6px 3px; height: 31px; right: 20px;" (click)="controlC( { resetitem:true, item:item.value })">
                            <i class="fa far fa-window-close"></i>
                        </span>
                    </div>

                    <!-- nbrDecimal -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='NUMBER'">
                        <div class="form-group row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <label class="col-sm-5">{{item.value.label| translatesplit:lang}}</label>

                            <div class="col-sm-5" *ngIf="item.value.isReadOnly ">
                                <div> {{(item.value.outputValue| number: '1.0-1' : 'en_US')| mcmpipe:item.value.unit}}
                                    {{item.value.unit|mcmunitpipe}}</div>
                            </div>

                            <div class="input-group input-group-sm col-sm-5" *ngIf="!item.value.isReadOnly && item.value.nbrDecimal > 0">
                                <input type="number" [id]="item.value.controlName" [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam" [(ngModel)]="item.value.outputValue"
                                    [min]="item.value.minValue" (blur)="controlC(item.value)" (change)="controlC(item.value)" (focus)="focusControl(item.value.controlName)" [step]="1/(item.value.nbrDecimal)*1"
                                    [max]="item.value.maxValue" class="form-control form-control-sm" />
                                <div class="input-group-append" *ngIf="item.value.unit">
                                    <div class="input-group-text">{{item.value.unit|mcmunitpipe}}</div>
                                </div>
                            </div>

                            <div class="input-group input-group-sm col-sm-5" *ngIf="!item.value.isReadOnly && item.value.nbrDecimal===0">
                                <input type="number" [id]="item.value.controlName" [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam" [(ngModel)]="item.value.outputValue"
                                    [min]="item.value.minValue" (blur)="controlC(item.value)" (change)="controlC(item.value)" (focus)="focusControl(item.value.controlName)" [step]="1" [max]="item.value.maxValue"
                                    class="form-control form-control-sm" />
                                <div class="input-group-append" *ngIf="item.value.unit">
                                    <div class="input-group-text">{{item.value.unit|mcmunitpipe}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Imagebox -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" [class.selected_widget]="item.value.selected" *ngIf="item.value.typ==='IMAGE'" style="text-align:center;">
                        <img [id]="item.value.controlName" alt="img" [src]="item.value.outputValue" style="width:100%;margin-bottom:10px;" />
                    </div>
                    <!-- Button -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" [class.selected_widget]="item.value.selected" *ngIf="item.value.typ==='BUTTON'" style="text-align:center;">
                        <div *ngIf="celllabels" style="position:relative;">
                            <div class="cell-label">{{item.value.cell}}</div>
                        </div>

                        <button [id]="item.value.controlName" class="btn btn-default form-group" (click)="controlC(item.value)">{{item.value.label|
                            translatesplit:lang}} </button>
                    </div>
                    <!-- SELECT -->
                    <div [class.selected_widget]="item.value.selected" *ngIf="item?.value?.typ==='SELECT'">
                        <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" class="form-group row">
                            <div *ngIf="celllabels" style="position:relative;">
                                <div class="cell-label">{{item.value.cell}}</div>
                            </div>

                            <label class="col-sm-4" [for]="item.value.controlName">{{item.value.label|
                                translatesplit:lang}}</label>

                            <!-- Check if any option contains images -->
                            <div *ngIf="hasImageOptions(item.value.selectOptions, item); else textSelect" class="col-sm-7" style="display: flex; gap: 4px;">
                                <!-- Image Select Button (looks like a select dropdown) -->
                                <div class="image-select-wrapper" style="position: relative; flex: 1;">
                                    <div class="image-select-button" (click)="toggleImageDropdown(item.value.controlName)"
                                        style="display: flex; align-items: center; justify-content: space-between; padding: 6px 12px; border: 1px solid #ced4da; border-radius: 4px; background: white; cursor: pointer; min-height: 38px;"
                                        [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam">

                                        <!-- Selected image preview or placeholder -->
                                        <div class="selected-preview" style="display: flex; align-items: center; flex: 1;">
                                            <div *ngIf="item.value.outputValue && getSelectedImageUrl(item); else noImageSelected" style="display: flex; align-items: center; gap: 8px;">
                                                <img [src]="getFirstImageUrl(getSelectedImageUrl(item))" [alt]="getSelectedImageValue(item)" loading="lazy"
                                                    style="width: 24px; height: 24px; object-fit: cover; border-radius: 3px;" (load)="onImageLoad(getFirstImageUrl(getSelectedImageUrl(item)))"
                                                    (error)="onImageError($event)">
                                                <span style="font-size: 12px; color: #333; margin-left: 4px;">
                                                    {{getSelectedImageValue(item)}}
                                                </span>
                                            </div>
                                            <ng-template #noImageSelected>
                                                <span style="color: #6c757d; font-size: 14px;">
                                                    Select an option...
                                                </span>
                                            </ng-template>
                                        </div>

                                        <!-- Dropdown arrow -->
                                        <i class="fas fa-chevron-down" style="color: #6c757d; font-size: 12px;"></i>
                                    </div>

                                    <!-- Dropdown content -->
                                    <div [hidden]="!isImageDropdownOpen(item.value.controlName)" class="image-dropdown-content"
                                        style="position: absolute; top: 100%; left: -60px; right: -60px; z-index: 1000; background: white; border: 1px solid #ced4da; border-top: none; border-radius: 0 0 4px 4px; max-height: 300px; overflow-y: auto; overflow-x: hidden; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">

                                        <div class="image-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 4px; padding: 12px;">
                                            <div *ngFor="let c of item.value.selectOptions; trackBy: trackImageOption" class="image-option" [class.selected]="item.value.outputValue === c.wert"
                                                (click)="selectImageOption(item, c.name); closeImageDropdown(item.value.controlName)"
                                                style="cursor: pointer; border: 2px solid transparent; border-radius: 6px; padding: 2px; transition: all 0.2s ease; aspect-ratio: 4/3; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);"
                                                [style.border-color]="item.value.outputValue === c.wert ? '#b84eff' : 'transparent'"
                                                [style.box-shadow]="item.value.outputValue === c.wert ? '0 2px 4px rgba(184, 78, 255, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.1)'"
                                                (mouseenter)="$event.target.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.15)'; $event.target.style.transform = 'translateY(-1px)'"
                                                (mouseleave)="$event.target.style.boxShadow = (item.value.outputValue === c.wert) ? '0 2px 4px rgba(184, 78, 255, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.1)'; $event.target.style.transform = 'translateY(0)'">

                                                <div *ngIf="isImageUrl(c.name); else imageTextOption" class="image-wrapper" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                                                    <img [src]="getFirstImageUrl(c.name)" [alt]="c.wert || 'Image'" loading="lazy"
                                                        style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px; border: 1px solid #ddd;" (load)="onImageLoad(getFirstImageUrl(c.name))"
                                                        (error)="onImageError($event)">
                                                </div>
                                                <ng-template #imageTextOption>
                                                    <div class="text-option"
                                                        style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; text-align: center; background: #f8f9fa;">
                                                        {{c.wert || c.name}}
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Manage Images Button -->
                                <button type="button" (click)="openMultiImageSelectDialog(item.value)"
                                    style="padding: 6px 8px; border: 1px solid #ced4da; border-radius: 4px; background: white; cursor: pointer; min-height: 38px; display: flex; align-items: center;"
                                    title="Manage image selection">
                                    <i class="fas fa-images" style="color: #6c757d; font-size: 14px;"></i>
                                </button>
                            </div>

                            <!-- Traditional text select for non-image options -->
                            <ng-template #textSelect>
                                <select class="col-sm-7" [id]="item.value.controlName" [class.inputedited]="item?.value?.edited" [class.inputisparam]="item?.value?.isparam" [(ngModel)]="item.value.outputValue"
                                    (focus)="focusControl(item.value.controlName)" (change)="controlC(item.value)" class="form-control form-control-sm">

                                    <option *ngFor="let c of item.value.selectOptions" [ngValue]="c.name">
                                        {{c.wert || c.name}}
                                    </option>
                                </select>
                            </ng-template>

                            <span *ngIf="item.value.edited" style="    padding: 6px 3px;    height: 31px;    right: 20px;" (click)="controlC( { resetitem:true, item:item.value })"><i
                                    class="fa  far far fa-window-close"></i></span>
                        </div>



                    </div>

                    <!-- html -->
                    <div [class]="item.value.cssclass" [id]="item.value.controlName+'-row'" [class.selected_widget]="item.value.selected" *ngIf="item.value.typ==='HTML'" style="text-align:center;">
                        <div *ngIf="celllabels" style="position:relative;">
                            <div class="cell-label">{{item.value.cell}}</div>
                        </div>

                        <div [innerHTML]="item.value.outputValue | safeHtml"></div>
                    </div>

                    <!-- Produkt/ProduktNoLabel -->
                    <!-- <div
                                *ngIf="(item?.value?.typ==='Produkt' || item?.value?.typ==='ProduktNoLabel') && item?.value?.produkte">

                                <div class="form-group row" [hidden]="item?.value?.hideprodukte">
                                    <label [for]="item.value.controlName" class="col-sm-4">{{item.value.label|
                                        translatesplit:lang}}</label>
                                    <select classs="col-sm-7" [id]="item.value.controlName"
                                        [class.inputedited]="item?.value?.edited"
                                        [class.inputisparam]="item?.value?.isparam" [(ngModel)]="item.value.outputValue"
                                        class="form-control form-control-sm col-sm-7"
                                        (focus)="focusControl(item.value.controlName)"
                                        (change)="controlC(item.value, true)">
                                        <option *ngFor="let c of item.value.produkte" [ngValue]="c.produktname">
                                            {{c|translateproduct:lang}}</option>
                                    </select>
                                    <span *ngIf="item.value.edited"
                                        style="    padding: 6px 3px;    height: 31px;    right: 20px;"
                                        (click)="controlC( { resetitem:true, item:item.value },true)"><i
                                            class="fa  far far fa-window-close"></i></span>
                                </div>
                                <div class="form-group row" *ngIf="item.value.selectOptions?.length >1">
                                    <label [for]="item.value.controlName" class="col-sm-4"><span
                                            [hidden]="!item?.value?.hideprodukte">{{item.value.label|
                                            translatesplit:lang}}</span></label>
                                    <select class="col-sm-7" [id]="item.value.controlName+'b'"
                                        [class.inputedited]="item?.value?.edited"
                                        [class.inputisparam]="item?.value?.isparam"
                                        [(ngModel)]="item.value.outputVarianteValue"
                                        class="form-control form-control-sm col-sm-7"  
                                        (focus)="focusControl(item.value.controlName+'b')"
                                        (change)="controlC(item.value)">
                                        <option *ngFor="let c of item.value.selectOptions" [ngValue]="c.name">
                                            {{c|translateproduct:lang}}</option>
                                    </select>
                       
                                </div>
                            </div> -->
                    <!-- -- Table -- -->
                    <!-- removed -->

                    <!-- <ng-container
                            *ngIf="item?.value?.childs && !(item?.value?.groupboxTyp==='Accordium') && !(item?.value?.groupboxTyp==='Tab') && !(item?.value?.typ==='Grid')"> -->

                </ng-container>

                <ng-container *ngIf="item?.value?.typ != 'TAB' && item?.value?.typ != 'EXPANSION'">
                    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item?.value?.childs  }">
                    </ng-container>
                </ng-container>



            </ng-container>

        </ng-container>



    </ng-template>





    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: jsongui?.childs  }">
    </ng-container>
</ng-container>





<!-- </div> -->